<template>
  <teleport to="body">
    <modal-base :show="modalActive" :title="modalTitle" :align-footer="'center'" @on-close="closeModal">
      <template #header>
        <h5 id="modalRoomingLabel" class="modal-title ms-2 ms-md-0">
          {{ t('rooming.organizarDistribucion') }}
          <InfoIcon size="12px" :message-info="t('rooming.tooltipMessage')" />
        </h5>
      </template>
      <template #body>
        <div class="d-flex flex-column flex-md-row text-primary">
          <span class="title me-2 d-flex align-items-center ms-2 ms-md-0">{{ roomingData.viaje.toUpperCase() }}</span>

          <span class="vr d-none d-md-block ms-2 vertical-rule"></span>

          <div class="mt-2 mt-md-0 d-flex align-items-center flex-md-row">
            <svg
              width="15"
              height="17"
              viewBox="0 0 15 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mx-md-3 ms-2 me-2">
              <path
                d="M7.5 14C7.64834 14 7.79334 13.956 7.91668 13.8736C8.04002 13.7912 8.13614 13.6741 8.19291 13.537C8.24968 13.4 8.26453 13.2492 8.23559 13.1037C8.20665 12.9582 8.13522 12.8246 8.03033 12.7197C7.92544 12.6148 7.7918 12.5433 7.64632 12.5144C7.50083 12.4855 7.35003 12.5003 7.21299 12.5571C7.07594 12.6139 6.95881 12.71 6.8764 12.8333C6.79399 12.9567 6.75 13.1017 6.75 13.25C6.75 13.4489 6.82902 13.6397 6.96967 13.7803C7.11032 13.921 7.30109 14 7.5 14ZM11.25 14C11.3983 14 11.5433 13.956 11.6667 13.8736C11.79 13.7912 11.8861 13.6741 11.9429 13.537C11.9997 13.4 12.0145 13.2492 11.9856 13.1037C11.9566 12.9582 11.8852 12.8246 11.7803 12.7197C11.6754 12.6148 11.5418 12.5433 11.3963 12.5144C11.2508 12.4855 11.1 12.5003 10.963 12.5571C10.8259 12.6139 10.7088 12.71 10.6264 12.8333C10.544 12.9567 10.5 13.1017 10.5 13.25C10.5 13.4489 10.579 13.6397 10.7197 13.7803C10.8603 13.921 11.0511 14 11.25 14ZM11.25 11C11.3983 11 11.5433 10.956 11.6667 10.8736C11.79 10.7912 11.8861 10.6741 11.9429 10.537C11.9997 10.4 12.0145 10.2492 11.9856 10.1037C11.9566 9.9582 11.8852 9.82456 11.7803 9.71967C11.6754 9.61478 11.5418 9.54335 11.3963 9.51441C11.2508 9.48547 11.1 9.50032 10.963 9.55709C10.8259 9.61386 10.7088 9.70998 10.6264 9.83332C10.544 9.95666 10.5 10.1017 10.5 10.25C10.5 10.4489 10.579 10.6397 10.7197 10.7803C10.8603 10.921 11.0511 11 11.25 11ZM7.5 11C7.64834 11 7.79334 10.956 7.91668 10.8736C8.04002 10.7912 8.13614 10.6741 8.19291 10.537C8.24968 10.4 8.26453 10.2492 8.23559 10.1037C8.20665 9.9582 8.13522 9.82456 8.03033 9.71967C7.92544 9.61478 7.7918 9.54335 7.64632 9.51441C7.50083 9.48547 7.35003 9.50032 7.21299 9.55709C7.07594 9.61386 6.95881 9.70998 6.8764 9.83332C6.79399 9.95666 6.75 10.1017 6.75 10.25C6.75 10.4489 6.82902 10.6397 6.96967 10.7803C7.11032 10.921 7.30109 11 7.5 11ZM12.75 2H12V1.25C12 1.05109 11.921 0.860322 11.7803 0.71967C11.6397 0.579018 11.4489 0.5 11.25 0.5C11.0511 0.5 10.8603 0.579018 10.7197 0.71967C10.579 0.860322 10.5 1.05109 10.5 1.25V2H4.5V1.25C4.5 1.05109 4.42098 0.860322 4.28033 0.71967C4.13968 0.579018 3.94891 0.5 3.75 0.5C3.55109 0.5 3.36032 0.579018 3.21967 0.71967C3.07902 0.860322 3 1.05109 3 1.25V2H2.25C1.65326 2 1.08097 2.23705 0.65901 2.65901C0.237053 3.08097 0 3.65326 0 4.25V14.75C0 15.3467 0.237053 15.919 0.65901 16.341C1.08097 16.7629 1.65326 17 2.25 17H12.75C13.3467 17 13.919 16.7629 14.341 16.341C14.7629 15.919 15 15.3467 15 14.75V4.25C15 3.65326 14.7629 3.08097 14.341 2.65901C13.919 2.23705 13.3467 2 12.75 2ZM13.5 14.75C13.5 14.9489 13.421 15.1397 13.2803 15.2803C13.1397 15.421 12.9489 15.5 12.75 15.5H2.25C2.05109 15.5 1.86032 15.421 1.71967 15.2803C1.57902 15.1397 1.5 14.9489 1.5 14.75V8H13.5V14.75ZM13.5 6.5H1.5V4.25C1.5 4.05109 1.57902 3.86032 1.71967 3.71967C1.86032 3.57902 2.05109 3.5 2.25 3.5H3V4.25C3 4.44891 3.07902 4.63968 3.21967 4.78033C3.36032 4.92098 3.55109 5 3.75 5C3.94891 5 4.13968 4.92098 4.28033 4.78033C4.42098 4.63968 4.5 4.44891 4.5 4.25V3.5H10.5V4.25C10.5 4.44891 10.579 4.63968 10.7197 4.78033C10.8603 4.92098 11.0511 5 11.25 5C11.4489 5 11.6397 4.92098 11.7803 4.78033C11.921 4.63968 12 4.44891 12 4.25V3.5H12.75C12.9489 3.5 13.1397 3.57902 13.2803 3.71967C13.421 3.86032 13.5 4.05109 13.5 4.25V6.5ZM3.75 11C3.89834 11 4.04334 10.956 4.16668 10.8736C4.29001 10.7912 4.38614 10.6741 4.44291 10.537C4.49968 10.4 4.51453 10.2492 4.48559 10.1037C4.45665 9.9582 4.38522 9.82456 4.28033 9.71967C4.17544 9.61478 4.0418 9.54335 3.89632 9.51441C3.75083 9.48547 3.60003 9.50032 3.46299 9.55709C3.32594 9.61386 3.20881 9.70998 3.1264 9.83332C3.04399 9.95666 3 10.1017 3 10.25C3 10.4489 3.07902 10.6397 3.21967 10.7803C3.36032 10.921 3.55109 11 3.75 11ZM3.75 14C3.89834 14 4.04334 13.956 4.16668 13.8736C4.29001 13.7912 4.38614 13.6741 4.44291 13.537C4.49968 13.4 4.51453 13.2492 4.48559 13.1037C4.45665 12.9582 4.38522 12.8246 4.28033 12.7197C4.17544 12.6148 4.0418 12.5433 3.89632 12.5144C3.75083 12.4855 3.60003 12.5003 3.46299 12.5571C3.32594 12.6139 3.20881 12.71 3.1264 12.8333C3.04399 12.9567 3 13.1017 3 13.25C3 13.4489 3.07902 13.6397 3.21967 13.7803C3.36032 13.921 3.55109 14 3.75 14Z"
                fill="var(--bs-primary)" />
            </svg>
            <span class="subtitle">
              {{ formatDate(roomingData.fechaInicio) }}
              <template v-if="roomingData.fechaInicio !== roomingData.fechaFin">
                - {{ formatDate(roomingData.fechaFin) }}
              </template>
            </span>
          </div>
        </div>
        <div class="contenido my-3 gap-2">
          <div class="columna-alojamientos">
            <div class="card-alojamiento-container">
              <CardAlojamientoRooming
                :rooming-data="roomingData"
                :usuarios="usuarios"
                :alojamiento-editando="alojamientoEditando"
                :habitacion-editando="habitacionEditando"
                :expanded-habitacion-id="expandedHabitacionId"
                @actualizar="actualizarHabitaciones"
                @is-editing="actualizarSeleccionables"
                @eliminar-integrante="eliminarIntegrante"
                @toggle-expand="toggleExpand" />
            </div>
          </div>
          <div class="columna-tabla">
            <TablaRooming
              :usuarios="usuariosTabla"
              :alojamiento-seleccionado="roomingData.nombre"
              :is-editing="editMode"
              @seleccionar-usuario="agregarIntegrante" />
          </div>
        </div>
      </template>
      <template #footer>
        <div v-if="estadoRooming === ESTADOS_ROOMING.EN_EDICION" class="d-flex gap-3 mb-1">
          <button class="text-primary btn-link" @click="closeModal()">{{ t('botones.cancelar') }}</button>
          <button class="btn btn-primary btn-guardar" @click="modalGuardarRoomingActive = true">
            {{ t('botones.guardar') }}
          </button>
        </div>
        <div v-else class="mb-1">
          <button class="btn btn-primary" @click="closeModal()">{{ t('botones.aceptar') }}</button>
        </div>
      </template>
    </modal-base>
  </teleport>

  <ModalGuardarRooming
    :rooming-data="roomingData"
    :modal-active="modalGuardarRoomingActive"
    @close-modal="closeGuardarRoomingModal()"
    @close-all-modals="closeAllModals()" />
</template>

<script setup>
  import { ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import CardAlojamientoRooming from '@/components/card/rooming/CardAlojamientoRooming.vue';
  import TablaRooming from '@/components/tablas/TablaRooming.vue';
  import InfoIcon from '@/components/Icons/InfoIcon.vue';
  import ModalBase from '@/components/modales/ModalBase.vue';
  import ModalGuardarRooming from '@/components/modales/Rooming/ModalGuardarRooming.vue';
  import { controlErrorAlojamientos } from '@/services/utils/ErrorControl';
  import { formatDate } from '@/helpers/dateUtiles';
  import { ESTADOS_ROOMING } from '@/constants/roomingConstants';

  const { t } = useI18n();

  const props = defineProps({
    roomingData: {
      type: Object,
      default: () => ({ habitaciones: [] }),
    },
    estadoRooming: {
      type: String,
      required: true,
    },
    modalActive: {
      type: Boolean,
      required: true,
    },
  });

  const emits = defineEmits(['actualizar', 'is-editing', 'close-modal']);

  const alojamientoSeleccionadoId = ref(null);
  const alojamientoEditandoId = ref(null);
  const habitacionEditandoId = ref(null);
  const expandedHabitacionId = ref(null);
  const editMode = ref(false);
  const usuariosTabla = ref([]);
  const modalGuardarRoomingActive = ref(false);

  const modalTitle = t('rooming.organizarDistribucion');

  function actualizarSeleccionables(isEditing, idAlojamiento, idHabitacion) {
    alojamientoEditandoId.value = idAlojamiento;
    habitacionEditandoId.value = idHabitacion;
    alojamientoSeleccionadoId.value = idAlojamiento;
    editMode.value = isEditing;
  }

  function actualizarHabitaciones(nuevasHabitaciones) {
    controlErrorAlojamientos('actualizar', nuevasHabitaciones);
  }

  const agregarIntegrante = usuario => {
    const habitacion = props.roomingData.habitaciones.find(h => h.id === habitacionEditandoId.value);
    if (habitacion && habitacion.integrantes.length < habitacion.numPlazas) {
      habitacion.integrantes.push(usuario);
      usuario.asignado = true;
      orderUsuariosTabla();
    }
  };

  function eliminarIntegrante(idHabitacion, integrante) {
    const habitacion = props.roomingData.habitaciones.find(h => h.id === idHabitacion);
    if (habitacion) {
      habitacion.integrantes = habitacion.integrantes.filter(i => i !== integrante);
      const usuario = usuariosTabla.value.find(u => u.id === integrante.id);
      if (usuario) {
        usuario.asignado = false;
        orderUsuariosTabla();
      }
    }
  }

  function orderUsuariosTabla() {
    usuariosTabla.value.sort((a, b) => a.id - b.id);
  }

  function toggleExpand(habitacionId) {
    expandedHabitacionId.value = habitacionId;
  }

  function closeModal() {
    emits('close-modal');
  }

  function closeGuardarRoomingModal() {
    modalGuardarRoomingActive.value = false;
  }

  function closeAllModals() {
    closeGuardarRoomingModal();
    closeModal();
  }

  function updateUsuariosTabla() {
    const usuariosSinAsignacion = props.roomingData.usuariosSinAsignacion || [];
    const habitaciones = props.roomingData.habitaciones || [];

    const habitacionesSinIntegrantes = habitaciones.map(habitacion => habitacion.integrantes.length === 0);
    const todasHabitacionesSinIntegrantes =
      habitacionesSinIntegrantes.filter(sinIntegrantes => sinIntegrantes).length === habitaciones.length;

    if (usuariosSinAsignacion.length === 0 && todasHabitacionesSinIntegrantes) {
      usuariosTabla.value = [];
      return;
    }

    const nuevosUsuarios = [
      ...usuariosSinAsignacion.map(usuario => ({ ...usuario, asignado: false })),
      ...habitaciones.flatMap(habitacion =>
        habitacion.integrantes.map(integrante => ({ ...integrante, asignado: true }))
      ),
    ];

    usuariosTabla.value = usuariosTabla.value.map(usuarioActual => {
      const usuarioNuevo = nuevosUsuarios.find(nuevo => nuevo.id === usuarioActual.id);
      return usuarioNuevo ? usuarioNuevo : usuarioActual;
    });

    nuevosUsuarios.forEach(usuarioNew => {
      if (!usuariosTabla.value.find(usuarioActual => usuarioActual.id === usuarioNew.id)) {
        usuariosTabla.value.push(usuarioNew);
      }
    });
  }

  watch(
    () => props.modalActive,
    () => {
      updateUsuariosTabla();
    },
    { immediate: true, deep: true }
  );
</script>

<style scoped lang="css">
  .modal-title {
    color: var(--bs-primary);
  }

  .modal-content {
    max-width: 1000px;
    margin: auto;
  }

  .contenido {
    display: flex;
    width: 100%;
    max-height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .columna-alojamientos {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-right: 20px;
    max-width: 45%;
  }

  .card-alojamiento-container {
    width: 100%;
  }

  .columna-tabla {
    flex: 1;
    max-width: 55%;
    min-width: 0;
  }

  .contenido::-webkit-scrollbar {
    width: 8px;
  }

  .contenido::-webkit-scrollbar-thumb {
    border-radius: var(--bs-border-radius-sm);
    background: rgba(var(--bs-primary-rgb), 0.2);
  }

  :deep(.rooming-modal) {
    max-width: 90vw !important;
    width: 100% !important;
  }

  :deep(.rooming-modal-content) {
    height: 85vh !important;
    background: white !important;
  }

  .modal-footer {
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .btn-link {
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.12px;
    text-decoration: underline;
    color: var(--bs-primary);
    border: none;
    background: none;
    cursor: pointer;
    padding: 0;
  }

  @media (max-width: 1024px) {
    :deep(.rooming-modal) {
      max-width: 95vw !important;
      width: 100% !important;
    }

    :deep(.rooming-modal-content) {
      height: 95vh !important;
    }
  }
  @media (max-width: 768px) {
    .columna-alojamientos,
    .columna-tabla {
      flex: 1;
      max-width: 55%;
    }

    .columna-alojamientos {
      margin-right: 2px;
    }

    :deep(.modal-body) {
      position: relative;
      flex: 1 1 auto;
      padding: 3px;
    }

    :deep(.modal-container) {
      padding-left: 8px;
      padding-right: 8px;
    }
  }

  .title {
    font-weight: 700;
  }
  .subtitle {
    font-weight: 500;
    font-size: 14px;
  }

  .vertical-rule {
    opacity: 1 !important;
  }

  .btn-guardar {
    box-shadow: 0px 1px 2px 0px rgba(var(--bs-primary-rgb), 0.35) !important;
    font-size: 14px;
    font-weight: 600;
    padding: 10px 20px;
  }
</style>
